




































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { dictServe, doublePrevention } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  mixins: [TableStripe],
})
export default class PublicProp extends Vue {
  visible = false;
  showWhat = false; // 保存、编辑、删除按钮的显示隐藏控制（true时显示保存，可编辑）
  canDisable = false; // 进入页面时，是否可编辑input
  isDisabled = false; // 当表格的当前行没有保存的时候就不能添加新的空数据
  helpFlag = false; // 按钮的显示隐藏
  title = '';
  formData: any = {
    annex: [], // 附件 "'123213','12334'"
    belongingToCompany: '', // 所属单位
    materialsStoreAddress: '', // 物资库地址
    measureUnit: '', // 计量单位
    name: '', // 物资名称
    principal: '', // 负责人
    principalContactNumber: '', // 负责人联系电话
    quantity: '', // 数量
    materialStatus: '',
    specificationModel: '', // 规格型号
    type: '', // 应急物资类型
    maintainRecord: [
      // {
      //   time: '', // 保养/维修时间
      //   content: '', // 保养/维修内容
      //   principal: '', // 负责人
      // },
    ], // 新增维修/保养记录
  };
  typeList: any = []; // 演练方式
  ruleForm: any = {
    name: [
      { required: true, message: '请输入物资名称' },
      // { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' },
    ],
    quantity: [
      { required: true, message: '数量不能为空' },
      { type: 'number', message: '数量必须为数字值' },
    ],
    principalContactNumber: [
      // { required: true, message: '负责人联系电话不能为空' },
      { required: true, validator: this.checkPrincipalContactNumber, trigger: 'blur' },
    ],
  };

  checkPrincipalContactNumber(rule: any, value: any, callback: any) {
    if (value === '') {
      callback(new Error('手机号不能为空'));
    } else if (!/^1\d{10}$/.test(value)) {
      callback(new Error('手机号格式错误'));
    } else {
      callback();
    }
  }

  showDialog(data: any) {
    this.headers.Authorization = localStorage.getItem('token');
    this.gettypeList(); // 获取演练方式的下拉
    switch (data.type) {
      case 'add':
        this.canDisable = false;
        this.title = '添加物资装备';
        break;
      case 'detail':
        this.canDisable = true;
        this.title = '物资装备详情';
        this.getDetail(data.data.id);
        break;
      case 'edit':
        this.canDisable = false;
        this.title = '编辑物资装备';
        this.getDetail(data.data.id);
        break;
      default:
        this.title = '';
    }
    this.visible = true;
  }

  /* 演练方式 的下拉 */
  gettypeList() {
    dictServe.getDetailsMapByName('emergencyMaterialsType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.typeList = helpArr;
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  hideDialog() {
    this.showWhat = false;
    this.isDisabled = false;
    this.fileList = [];
    this.formData.maintainRecord = [];
    this.formData.annex = [];
    this.visible = false;
    this.formData = {};
    this.$emit('getTableData');
  }

  submitForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      if (this.title === '添加物资装备') this.addEmergencyDrillRecord();
      if (this.title === '编辑物资装备') this.editEmergencyDrillRecord();
    });
  }

  /* 新增的接口 */
  addEmergencyDrillRecord() {
    doublePrevention
      .addEmergencyMaterials({
        ...this.formData,
        annex: this.formData.annex !== [] ? this.formData.annex.toString() : '',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 编辑的接口 */
  editEmergencyDrillRecord() {
    doublePrevention
      .editEmergencyMaterials({
        ...this.formData,
        annex: this.formData.annex !== [] ? this.formData.annex.toString() : '',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 详情的接口 */
  getDetail(id: any) {
    doublePrevention.getSingleEmergencyMaterials(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (res.data.annexList !== []) {
          this.fileList = res.data.annexList;
          const a: any = [];
          a.push(res.data.annex);
          this.formData.annex = a;
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  tableDataAdd(type: any, data: any) {
    if (type === 'out') {
      this.isDisabled = true;
      this.showWhat = false;
      this.helpFlag = false;
      this.formData.maintainRecord.push({
        time: '',
        content: '',
        principal: '',
      });
    }
    if (type === 'in') {
      // 单行的保存按钮
      if (data.time === '') {
        this.$message.warning('选择保养/维修时间');
      } else if (data.content === '') {
        this.$message.warning('请输入保养/维修内容');
      } else if (data.principal === '') {
        this.$message.warning('请输入负责人');
      } else {
        this.helpFlag = true;
        this.isDisabled = false;
        this.showWhat = true;
      }
    }
  }

  tableDataEdit(data: any) {
    this.showWhat = !this.showWhat;
    this.helpFlag = false;
  }

  tableDataDelete(data: any) {
    this.formData.maintainRecord.splice(data.$index, 1);
  }

  /* 导入用到的 */
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
  private headers: any = {};
  private fileList: any = [];
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
    const helpArr: any = [];
    this.fileList.forEach((item: any) => {
      console.log(item);
      // helpArr.push(item.id);
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.annex = helpArr;
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'GIF' || suffix === 'SVG' || suffix === 'PDF' || suffix === 'TXT' || suffix === 'DOC' || suffix === 'DOCX' || suffix === 'XLSX' || suffix === 'XLS' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'gif' || suffix === 'svg' || suffix === 'pdf' || suffix === 'txt' || suffix === 'doc' || suffix === 'docx' || suffix === 'xlsx' || suffix === 'xls') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP,GIF,SVG,PDF,TXT,DOC,DOCX,XLSX,XLS！');
      return false;
    }
  }

  private handleAvatarCardFrontSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.annex = arr;
  }
}
